import { render, staticRenderFns } from "./EditProfileTable.vue?vue&type=template&id=8daaac20&scoped=true"
import script from "./EditProfileTable.vue?vue&type=script&lang=js"
export * from "./EditProfileTable.vue?vue&type=script&lang=js"
import style0 from "./EditProfileTable.vue?vue&type=style&index=0&id=8daaac20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8daaac20",
  null
  
)

export default component.exports